import { useState, useEffect } from "react";
import API_URL from "../../const";
import HeaderPrivate from "../../Components/HeaderPrivate";
import Cards from "./components/Cards";
import Spinner from "../../Components/Spinner/Spinner";
import { useNavigate } from "react-router-dom";
import Toast from "../../Components/Toast/Toast";
import ToastInfo from "../../Components/Toast/ToastInfo";
import DetailPage from "./components/DetailPage";
import FooterTransparent from "../../Components/footerTransparente";

export default function CatalogoLogin() {
  const [IsOpenSpinner, setIsOpenSpinner] = useState(false);
  const [showToastInfo, setShowToastInfo] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [error, setError] = useState("");
  const [empresaData, setEmpresaData] = useState(null);
  const [showCards, setShowCards] = useState(true);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const baseHeaders = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const Buscar = (uuid) => {
    // Validar UUID antes de hacer la petición
    if (!uuid || uuid.trim() === "") {
      setError("UUID de empresa inválido");
      setShowToastInfo(true);
      setTimeout(() => setShowToastInfo(false), 5000);
      return;
    }

    setIsOpenSpinner(true);
    setError("");

    fetch(`${API_URL}getEmpresaDetalles.php?uuid=${uuid}`, {
      method: "GET",
      headers: baseHeaders,
      mode: "cors",
    })
      .then((response) => {
        // Validar el estado HTTP
        if (!response.ok) {
          if (response.status === 401) {
            throw new Error(
              "Sesión expirada. Por favor inicia sesión nuevamente.",
            );
          } else if (response.status === 403) {
            throw new Error("No tienes permisos para ver esta información.");
          } else if (response.status === 404) {
            throw new Error("Empresa no encontrada.");
          } else {
            throw new Error(`Error del servidor: ${response.status}`);
          }
        }
        return response.text();
      })
      .then((text) => {
        // Limpiar respuesta de posibles caracteres extra
        let cleanText = text.trim();

        // Intentar encontrar JSON válido
        const startIndex = cleanText.indexOf("[{");
        const endIndex = cleanText.lastIndexOf("}]") + 2;

        if (startIndex !== -1 && endIndex > startIndex) {
          cleanText = cleanText.substring(startIndex, endIndex);
        } else if (cleanText.startsWith("{")) {
          // Si es un objeto con error
          const errorData = JSON.parse(cleanText);
          if (errorData.error) {
            throw new Error(errorData.error);
          }
        }

        try {
          const responseData = JSON.parse(cleanText);

          // Validar que sea un array con datos
          if (!Array.isArray(responseData)) {
            throw new Error("Formato de respuesta inválido");
          }

          if (responseData.length === 0) {
            throw new Error("No se encontró información de la empresa");
          }

          // Validar datos mínimos de la empresa
          const empresaInfo = responseData[0];
          if (!empresaInfo || !empresaInfo.uuid) {
            throw new Error("Datos de empresa incompletos");
          }

          setEmpresaData(responseData);
          setShowCards(false);
          setError("");
          setIsOpenSpinner(false);
        } catch (parseError) {
          console.error("Error al procesar datos:", parseError);
          throw new Error("Error al procesar la información de la empresa");
        }
      })
      .catch((error) => {
        console.error("Error al cargar empresa:", error);
        setIsOpenSpinner(false);

        const errorMessage = error.message || "Error al cargar la información";
        setError(errorMessage);
        setShowToastInfo(true);

        // Si es error de autenticación, redirigir al login
        if (
          errorMessage.includes("Sesión expirada") ||
          errorMessage.includes("Token")
        ) {
          setTimeout(() => {
            localStorage.clear();
            navigate("/login");
          }, 2000);
        } else {
          setTimeout(() => setShowToastInfo(false), 5000);
        }
      });
  };

  useEffect(() => {
    if (!token) {
      setError("Tu sesión ha expirado, autentícate nuevamente.");
      setShowToastInfo(true);
      setTimeout(() => {
        setShowToastInfo(false);
      }, 5000);

      navigate("/login");
    } else {
      if (empresaData) {
        setShowCards(false);
      }
    }
  }, [empresaData]);

  const handleVolverCatalogo = () => {
    setEmpresaData(null);
    setShowCards(true);
    setError("");
  };

  const idRol_fk = localStorage.getItem("idRol_fk");
  const isAuthorized = idRol_fk === "1" || idRol_fk === "2" || idRol_fk === "4";

  return (
    <div className="absolute left-0 right-0 h-screen justify-between">
      <Spinner isOpen={IsOpenSpinner}></Spinner>
      <HeaderPrivate />
      <Toast
        isOpen={showToast}
        title="Éxito"
        text="Empresa encontrada"
      />
      <ToastInfo
        isOpen={showToastInfo}
        title={error ? "Error" : "Búsqueda"}
        text={error || "Empresa no encontrada"}
      />
      <section className="bg-white mb-10">
        <div className="container px-6 py-12 mt-5 mx-auto">
          {isAuthorized && showCards && (
            <Cards isAuthorized={isAuthorized} Buscar={Buscar} />
          )}
          {empresaData && (
            <>
              <button
                onClick={handleVolverCatalogo}
                className="mb-6 flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 font-medium"
              >
                <i className="bx bx-arrow-back text-xl"></i>
                Volver al catálogo
              </button>
              <DetailPage empresaData={empresaData} />
            </>
          )}
        </div>
      </section>
      <div className="fixed bottom-0 left-0 right-0">
        <FooterTransparent></FooterTransparent>
      </div>
    </div>
  );
}
